import { Link, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import parse from "html-react-parser";
import React from "react";
import { colours } from "../../shared/colors";

/**
 * Component for rendering question text with HTML formatting.
 *
 * @component
 * @param {Object} props - The component's props.
 * @param {string} props.questionText - The text of the question, which may contain HTML tags and line breaks.
 * @returns {JSX.Element} - Rendered question text as a React element.
 */
export const QuestionText = (props: any) => {
	return (
		<div className="questionText">
			{parse(props.questionText.replace(/(\\n)/g, "\n").replace(/<br\/>/g, "\n"))}
			{props.questionText.toUpperCase().includes("STAMP DUTY") && (
				<Tooltip
					title={
						<React.Fragment>
							<Link
								href="https://www.revenue.nsw.gov.au/taxes-duties-levies-royalties/insurance-duty/small-business-exemption#:~:text=The%20entity%20is%20carrying%20on,is%20less%20than%20%242%20million."
								target="_blank"
								rel="noopener"
								color="inherit"
							>
								{
									"Small businesses in NSW may be exempt from stamp duty on insurance products if they qualify as a small business. Please check the Revenue NSW website for more information."
								}
							</Link>
						</React.Fragment>
					}
					placement="right"
				>
					<span style={{ paddingLeft: "0.5em" }}>
						<InfoOutlinedIcon
							sx={{
								fontSize: "1em",
								color: colours.primaryDark.main,
							}}
						/>
					</span>
				</Tooltip>
			)}
		</div>
	);
};
